import { call, put, takeLatest } from "redux-saga/effects";
import { schema } from "normalizr";
import { authorizedRequest } from "utils/api";
import moment from "moment";

export const PREPAYMENT_CALCULATE_REQUEST = "PREPAYMENT_CALCULATE_REQUEST";
export const PREPAYMENT_CALCULATE_FAILURE = "PREPAYMENT_CALCULATE_FAILURE";
export const PREPAYMENT_CALCULATE_SUCCESS = "PREPAYMENT_CALCULATE_SUCCESS";

export const PREPAYMENT_CALCULATE_DEAL_REQUEST =
  "PREPAYMENT_CALCULATE_DEAL_REQUEST";
export const PREPAYMENT_CALCULATE_DEAL_FAILURE =
  "PREPAYMENT_CALCULATE_DEAL_FAILURE";
export const PREPAYMENT_CALCULATE_DEAL_SUCCESS =
  "PREPAYMENT_CALCULATE_DEAL_SUCCESS";

export const PREPAYMENT_KEY = "prepayment";
export const PREPAYMENT_ENTITY = new schema.Entity(PREPAYMENT_KEY, {});
export const PREPAYMENT_SCHEMA = [PREPAYMENT_ENTITY];

export const initialState = {
  date: new Date(),
  values: {
    prepaymentDate: new Date(),
    amount: null,
    startDate: new Date(),
    maturityDate: moment().add(10, "years"),
    date: null,
    daycount: "Act/360",
    rateType: "Fixed",
    interestRate: null,
    interestIndex: null,
    loanSpread: null,
    amortTerm: null,
    amortType: null,
    ioPeriod: null,
    prepaymentType: null,
    amortization: "false"
  },
  penalty: null
};

export default function prepaymentReducer(state = initialState, action) {
  const { type, payload, error } = action;
  switch (type) {
    case PREPAYMENT_CALCULATE_DEAL_SUCCESS:
      return {
        penalty: payload.penalty,
        date: payload.date
      };

    case PREPAYMENT_CALCULATE_SUCCESS:
      return {
        values: payload.body,
        penalty: payload.data.penalty
      };

    case PREPAYMENT_CALCULATE_FAILURE:
      return {
        values: error.data.body,
        error: error.data.error,
        status: error.data.status
      };

    default:
      return state;
  }
}

// CALCULATE Prepayment ON A DEAL
export function calculatePrepaymentOnADeal(dealId, date) {
  return {
    type: PREPAYMENT_CALCULATE_DEAL_REQUEST,
    payload: {
      dealId,
      date
    }
  };
}
export function calculatePrepaymentOnADealSuccess(payload) {
  return {
    type: PREPAYMENT_CALCULATE_DEAL_SUCCESS,
    payload
  };
}
export function calculatePrepaymentOnADealFailure(error) {
  return {
    type: PREPAYMENT_CALCULATE_DEAL_FAILURE,
    error
  };
}

// CALCULATE Prepayment Standalone
export function calculatePrepayment(values) {
  return {
    type: PREPAYMENT_CALCULATE_REQUEST,
    payload: values
  };
}
export function calculatePrepaymentSuccess(payload) {
  return {
    type: PREPAYMENT_CALCULATE_SUCCESS,
    payload
  };
}
export function calculatePrepaymentFailure(error) {
  return {
    type: PREPAYMENT_CALCULATE_FAILURE,
    error
  };
}

// Saga CALCULATE Prepayment on a deal
function* calculatePrepaymentOnADealSaga({ payload }) {
  try {
    const response = yield call(
      authorizedRequest,
      `/deals/${payload.dealId}/prepayment`,
      "POST",
      payload.date
    );
    yield put(calculatePrepaymentOnADealSuccess(response));
  } catch (error) {
    yield put(calculatePrepaymentOnADealFailure(error));
  }
}

// Saga CALCULATE Prepayment standalone
function* calculatePrepaymentSaga({ payload }) {
  try {
    const response = yield call(
      authorizedRequest,
      "/calculators/prepayment",
      "POST",
      payload
    );
    yield put(calculatePrepaymentSuccess(response));
  } catch (error) {
    yield put(calculatePrepaymentFailure(error.response));
  }
}

export function* prepaymentSaga() {
  yield takeLatest(
    PREPAYMENT_CALCULATE_DEAL_REQUEST,
    calculatePrepaymentOnADealSaga
  );
  yield takeLatest(PREPAYMENT_CALCULATE_REQUEST, calculatePrepaymentSaga);
}
